var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwayTopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5485 1.00586C10.5485 1.00586 9.75173 1.29411 8.5002 1.29411C7.24868 1.29411 6.45187 1.00586 6.45187 1.00586C6.32596 1.00586 6.20096 1.02779 6.08215 1.07072L0.665039 3.02361L1.24673 6.19436L2.95648 6.39326C3.16585 6.41766 3.35867 6.52229 3.49662 6.68636C3.63458 6.85043 3.70759 7.06195 3.70117 7.2789L3.46331 15.9949H13.5371L13.2992 7.2789C13.2928 7.06195 13.3658 6.85043 13.5038 6.68636C13.6417 6.52229 13.8346 6.41766 14.0439 6.39326L15.7537 6.19436L16.3354 3.02361L10.9183 1.07072C10.7994 1.02779 10.6744 1.00586 10.5485 1.00586Z",
    fill: "#6D7283",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwayTopIcon);
export default __webpack_public_path__ + "static/media/away-top-icon.2c7ee671ed0d0bd2ea886460859821d5.svg";
export { ForwardRef as ReactComponent };